<script setup lang="ts">
import CustomerManagement from "@/views/playground/planner/business-management/customer-management/CustomerManagement.vue";
</script>

<template>
  <customer-management></customer-management>
</template>

<style scoped></style>
